import React from 'react';

import { LOCAL_COLORS } from 'styles/constants';

import { ACNE_ROSACEA, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_CUSTOM_FORMULA_CONTENT: IngredientsProps = {
  header: (
    <React.Fragment>
      Proven ingredients, picked for <br />
      your goals
    </React.Fragment>
  ),
  ingredients: INGREDIENTS[ACNE_ROSACEA],
  backgroundColor: LOCAL_COLORS.surfaceWhite,
};
